/* eslint-disable import/prefer-default-export */

export const PADDING_X = 4;
